import Axios from "axios";

const instance = Axios.create({
  baseURL: "https://youtube.googleapis.com/youtube/v3/",
});
export { instance };

export const DefaultSearch =
  "videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US";



  // GET https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key=[YOUR_API_KEY] HTTP/1.1

